export default __webpack_public_path__ + "static/media/ChandosBook@2x.62d05129.jpg";